/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'done': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm5.605 6.304a1.01 1.01 0 00-1.454.01l-4.93 4.994L6.85 8.91a1.02 1.02 0 00-1.454 0l-.093.094a1.046 1.046 0 000 1.47l3.187 3.221a1.02 1.02 0 001.454 0l5.755-5.828a1.046 1.046 0 000-1.47z" _fill="#687682" fill-rule="evenodd"/>'
  }
})
